import 'ng-youtube-embed';
export const REVIEWS = 'mashservise.reviews';

import templateUrl from './reviews.html';
import {ReviewController} from './reviews.controller';
angular.module(REVIEWS, ['ngYoutubeEmbed'])
    .component('reviews', {
        controller: ReviewController,
        controllerAs: 'ctrl',
        templateUrl: templateUrl
    });


// WEBPACK FOOTER //
// ./src/app/modules/reviews/index.js